import { useEffect } from "react";

export default function SEO({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} · Tanonshop` : "Tanonshop · Handmade Custom Cushion Covers";
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
    window.scrollTo(0, 0);
  }, [title, description]);
  return null;
}
